'use client';

import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body className="antialiased bg-[#121118] min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-6 py-24 text-center px-4">
          <h2 className="text-2xl font-semibold text-white">Something went wrong</h2>
          <p className="text-white/60 max-w-md">Please refresh the page and try again.</p>
          <button
            onClick={() => reset()}
            className="rounded-xl bg-[#FD481D] px-6 py-3 text-white font-medium hover:bg-[#FD481D]/90 transition-colors"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
